import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offer-management',
  templateUrl: './offer-management.component.html',
  styleUrls: ['./offer-management.component.scss']
})
export class OfferManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
